module.exports = __webpack_public_path__ + "static/kuo-toa-3205614e17678eb9d30968eb711e9142.jpg";